import React, { useState, useEffect } from "react"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { useAuth } from "../../contexts/AuthContext"
import axios from "axios"

import "../login/LoginComponent.sass"

import { toast } from "react-toastify"

function FormRegister({
  setters,
  email,
  firstAccess,
  handler,
  isLinkExpired,
  setIsLinkExpired,
}) {
  const navigate = useNavigate()
  const [setPwd, setPwdAgain] = setters
  const [passwordStrength, setPasswordStrength] = useState({
    length: false,
    specialChar: false,
    number: false,
    uppercase: false,
    lowercase: false,
  })

  const handlePwdSet = handler

  const formTitle = firstAccess ? "Cadastre sua senha" : "Insira a nova senha"

  const checkPasswordStrength = (password) => {
    const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)

    setPasswordStrength({
      length: password.length >= 8,
      specialChar: hasSpecialChar,
      number: /\d/.test(password),
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
    })
  }

  const handleGoToLogon = () => {
    setIsLinkExpired(false)
    navigate("/login")
  }

  return isLinkExpired ? (
    <form>
      <div className="form-header">
        <span className="font text-4">Link expirado</span>
      </div>

      <div className="form-content">
        <span className="font text-2">
          Este link não está mais ativo. Para solicitar uma nova senha, use a
          opção 'Esqueci minha senha' na tela de logon.
        </span>
        <input
          type="submit"
          className="action-btn"
          value="Tela de logon"
          onClick={handleGoToLogon}
        />
      </div>
    </form>
  ) : (
    <form onSubmit={handlePwdSet}>
      <div className="form-header">
        <span className="font text-4">{formTitle}</span>
      </div>

      <div className="form-content">
        <label htmlFor="user" className="font text-2">
          E-mail
        </label>
        <input type="text" name="email" id="email" disabled value={email} />
        <label htmlFor="pass" className="font text-2">
          Senha
        </label>
        <input
          type="password"
          name="pass"
          className="dismiss-bottom-margin"
          id="pass"
          onChange={(event) => {
            setPwd(event.target.value)
            checkPasswordStrength(event.target.value)
          }}
        />
        <div className="password-requirements">
          <ul>
            <li
              className={
                passwordStrength.lowercase ? "fulfilled" : "unfulfilled"
              }
            >
              Caracteres minúsculos
            </li>
            <li
              className={
                passwordStrength.uppercase ? "fulfilled" : "unfulfilled"
              }
            >
              Caracteres maiúsculos
            </li>
            <li
              className={passwordStrength.number ? "fulfilled" : "unfulfilled"}
            >
              Números
            </li>
            <li
              className={
                passwordStrength.specialChar ? "fulfilled" : "unfulfilled"
              }
            >
              Caracteres especiais
            </li>
            <li
              className={passwordStrength.length ? "fulfilled" : "unfulfilled"}
            >
              No mínimo 8 caracteres
            </li>
          </ul>
        </div>
        <label htmlFor="pass" className="font text-2">
          Senha novamente
        </label>
        <input
          type="password"
          name="pass"
          id="pass-again"
          onChange={(event) => {
            setPwdAgain(event.target.value)
          }}
        />
        <input type="submit" value="Enviar" className="action-btn" />
      </div>
    </form>
  )
}

function RegisterComponent() {
  const navigate = useNavigate()

  const [email, setEmail] = useState()
  const [userId, setUserId] = useState()
  const [pwd, setPwd] = useState()
  const [pwdAgain, setPwdAgain] = useState()

  const [userToken, setUserToken] = useState()
  const [firstAccess, setFirstAccess] = useState()

  const [isLinkExpired, setIsLinkExpired] = useState(false)

  const location = useLocation()

  useEffect(() => {
    const fetchData = async () => {
      const queryParams = new URLSearchParams(location.search)
      const firstAccessInt = queryParams.get("fa") == 1 ? 1 : 0

      setUserToken(queryParams.get("u"))
      setFirstAccess(queryParams.get("fa") == 1 ? true : false)

      try {
        const response = await axios.get(
          process.env.REACT_APP_API_URL +
            "user/user-registration/" +
            queryParams.get("u") +
            "/" +
            firstAccessInt
        )
        setIsLinkExpired(false)
        setEmail(response.data.user.email)
        setUserId(response.data.userId)
      } catch (error) {
        console.log(error)
        if (error.response && error.response.status === 404) {
          setIsLinkExpired(true)
          toast.error(error.response?.data?.error, {
            theme: "colored",
          })
        } else {
          toast.error(error.response?.data?.error || "Ocorreu um erro", {
            theme: "colored",
          })
        }
      }
    }

    fetchData()
  }, [])

  const isInvalidFormData = (array) => {
    array.some((item) => {
      return item == null || item == "" ? true : false
    })
  }

  const handlePwdSet = async (e) => {
    e.preventDefault()

    const body = {
      userId,
      userToken,
      pwd,
      fa: firstAccess,
    }

    if (pwd != pwdAgain) {
      return toast.error("As senhas devem coincidir")
    }

    if (isInvalidFormData([pwd, pwdAgain])) {
      return toast.error("Preencha os campos", { theme: "colored" })
    } else {
      await axios
        .post(process.env.REACT_APP_API_URL + "user/set-pwd", body)
        .then((response) => {
          toast.success("Senha atualizada com sucesso, prossiga com o login", {
            theme: "colored",
          })

          navigate("/login")
        })
        .catch((error) => {
          return toast.error("Ocorreu um erro no registro de senha", {
            theme: "colored",
          })
        })
    }
  }

  return (
    <div className="form-wrapper">
      <FormRegister
        setters={[setPwd, setPwdAgain]}
        email={email}
        firstAccess={firstAccess}
        handler={handlePwdSet}
        isLinkExpired={isLinkExpired}
        setIsLinkExpired={setIsLinkExpired}
      />
      <div className="aside-img-div">
        <img src="/assets/images/logo.png" className="bottom-form-logo" />
      </div>
    </div>
  )
}

export default RegisterComponent
